import { render, staticRenderFns } from "./ChuyenTrangThaiXuLyPhanHoi.vue?vue&type=template&id=87630442&"
import script from "./ChuyenTrangThaiXuLyPhanHoi.vue?vue&type=script&lang=js&"
export * from "./ChuyenTrangThaiXuLyPhanHoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports